export default "__VITE_ASSET__41830d3c__"